const en = require('./cookie_consent/en.js')
const cs = require('./cookie_consent/cs.js')
const sk = require('./cookie_consent/sk.js')

// obtain plugin
var cc = initCookieConsent();
window.cc = cc
// run plugin with your configuration
cc.runWithLocale = locale => cc.run({
    current_lang: locale || document.documentElement.getAttribute('lang') || 'en',
    // auto_language: 'document',
    // autoclear_cookies: true,                   // default: false
    // theme_css: '<path-to-cookieconsent.css>',  // 🚨 replace with a valid path
    page_scripts: true,                        // default: false

    // mode: 'opt-in'                          // default: 'opt-in'; value: 'opt-in' or 'opt-out'
    // delay: 0,                               // default: 0
    autorun: true,                          // default: true
    force_consent: true,                   // default: false
    // hide_from_bots: false,                  // default: false
    // remove_cookie_tables: false             // default: false
    // cookie_name: 'cc_cookie',               // default: 'cc_cookie'
    // cookie_expiration: 182,                 // default: 182 (days)
    // cookie_necessary_only_expiration: 182   // default: disabled
    // cookie_domain: location.hostname,       // default: current domain
    // cookie_path: '/',                       // default: root
    // cookie_same_site: 'Lax',                // default: 'Lax'
    // use_rfc_cookie: false,                  // default: false
    // revision: 0,                            // default: 0

    gui_options: {
        consent_modal: {
            layout: 'cloud',                    // box,cloud,bar
            position: 'middle center',          // bottom,middle,top + left,right,center
            transition: 'slide'                 // zoom,slide
        },
        settings_modal: {
            layout: 'box',                      // box,bar
            position: 'left',                   // right,left (available only if bar layout selected)
            transition: 'slide'                 // zoom,slide
        }
    },


    onFirstAction: function(user_preferences, cookie){
    },

    onAccept: function (cookie) {
        // ...
    },

    onChange: function (cookie, changed_preferences) {
        location.reload()
    },

    languages: {
      en,
      cs,
      sk
    }
});

cc.runWithLocale()
